import { EnvironmentOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDelayedLoading } from '@/hooks';
import { Location } from '@/models';
import { useLocations } from '@/web-api/locations';

import { LocationList } from './LocationList';
import { LocationModal } from './LocationModal';

export const Locations = () => {
  const { t } = useTranslation();
  const { data: locations, isLoading } = useLocations();
  const showDelayedLoading = useDelayedLoading(isLoading);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);

  const handleCreate = () => {
    setModalMode('create');
    setSelectedLocation(null);
    setModalOpen(true);
  };

  const handleEdit = (location: Location) => {
    setModalMode('edit');
    setSelectedLocation(location);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLocation(null);
  };

  return (
    <Space orientation='vertical' style={{ width: '100%' }}>
      <LocationList
        locations={locations}
        isLoading={showDelayedLoading}
        onEdit={handleEdit}
        header={
          <Flex justify='space-between'>
            <Typography.Text>{t('common:locationsHeader')}</Typography.Text>
            <Button
              aria-label={t('common:newLocation')}
              type='primary'
              icon={<EnvironmentOutlined />}
              onClick={handleCreate}
            >
              {t('common:newLocation')}
            </Button>
          </Flex>
        }
      />
      <LocationModal
        mode={modalMode}
        location={selectedLocation}
        open={modalOpen}
        onClose={handleCloseModal}
      />
    </Space>
  );
};
